




























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import CreateNotice from "./createnotice.vue";
import EditNotice from "./editnotice.vue";
import SearchTree from "@/lib/Common/searchtree";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageLogsRequest extends PageRequest {
  keyword: string;
  areaId: number;
  operationType: number;
  startTime: string;
  endTime: string;
}

@Component({
  components: { CreateNotice, EditNotice },
})
export default class Notic extends AbpBase {
  //filters
  pagerequest: PageLogsRequest = new PageLogsRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  splitnum: number = 0.15;
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  //修改
  edit() {
    this.editModalShow = true;
  }
  //新增
  create() {
    this.createModalShow = true;
  }
  //排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //列表
  get list() {
    return this.$store.state.notice.list;
  }
  get loading() {
    return this.$store.state.notice.loading;
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("notice/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("notice/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("notice/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    if (this.pagerequest.startTime == null) {
      this.pagerequest.startTime = Moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    if (this.pagerequest.endTime == null) {
      this.pagerequest.endTime = Moment()
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    await this.$store.dispatch({
      type: "notice/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.notice.pageSize;
  }
  get totalCount() {
    return this.$store.state.notice.totalCount;
  }
  get currentPage() {
    return this.$store.state.notice.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Title"),
      key: "title",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.title,
            },
          },
          params.row.title
        );
      },
    },
    {
      title: this.L("Content"),
      key: "content",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.content,
            },
          },
          params.row.content
        );
      },
    },
    {
      sortable: true,
      title: this.L("EffectiveTime"),
      key: "effectiveTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.effectiveTime == null
            ? ""
            : Moment(params.row.effectiveTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Level"),
      key: "level",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.level;
        let str = this.L("Unknown");
        switch (id) {
          case 1:
            str = this.L("SuddenNotice");
            break;
          case 2:
            str = this.L("AdvanceNotice");
            break;
          case 3:
            str = this.L("PopUpNotice");
            break;
        }
        return h("span", str);
      },
    },
    {
      title: this.L("IsShow"),
      key: "isShow",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isShow ? this.L("Showing") : this.L("Showed")
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('noticeDel');
        let edit = this.checkButtonAuth('noticeEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("notice/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "notice/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.pagerequest.startTime = Moment()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .add(15, "d")
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getAreaTree();
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  // 时间触发
  changeTime(time) {
    this.pagerequest.startTime = Moment(time[0], "YYYY-MM-DD HH:mm:ss")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment(time[1])
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
    //console.log(this.pagerequest)
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      options2: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
}
